import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef } from 'react';
import ArrowheadDown from '@elliemae/ds-icons/ArrowheadDown';
import ArrowheadRight from '@elliemae/ds-icons/ArrowheadRight';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSButton from '@elliemae/ds-basic/Button';
import DSTruncatedTooltipText from '@elliemae/ds-basic/TruncatedTooltipText';
import { dataGridBlockName } from '../../blockNames.js';
import { RowSizes } from '../../rowSizes.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var blockName = "".concat(dataGridBlockName, "-expandable-column"); // todo: clean this when we move to css-js

var ExpandableColumnWrapper = aggregatedClasses('div')(blockName);
var LabelDescriptionWrapper = aggregatedClasses('div')(blockName, 'label-description-wrapper');
var Label = aggregatedClasses('span')(blockName, 'label');
var Description = aggregatedClasses('span')(blockName, 'description');
var ExtraColumnData = aggregatedClasses('div')(blockName, 'extra-column-data');
var ExpandableMasterWrapper = aggregatedClasses('div')("".concat(blockName, "-master-wrapper"));
var ExpandableDetailsWrapper = aggregatedClasses('div')("".concat(blockName, "-details-wrapper"));

function ExpandableColumnCell(_ref) {
  var label = _ref.label,
      description = _ref.description,
      isExpanded = _ref.isExpanded,
      expandableDetails = _ref.expandableDetails,
      extraData = _ref.extraData,
      onToggleExpand = _ref.onToggleExpand;
  var ref = useRef();
  return /*#__PURE__*/React.createElement(ExpandableColumnWrapper, {
    ref: ref,
    tabindex: 0
  }, /*#__PURE__*/React.createElement(ExpandableMasterWrapper, {
    style: {
      height: RowSizes.extend
    }
  }, /*#__PURE__*/React.createElement(DSButton, {
    buttonType: "text",
    className: "expandable-arrow",
    icon: isExpanded ? /*#__PURE__*/React.createElement(ArrowheadDown, null) : /*#__PURE__*/React.createElement(ArrowheadRight, null),
    onClick: function onClick(e) {
      onToggleExpand(e);

      if (ref && ref.current) {
        ref.current.focus();
      }
    },
    size: "s"
  }), /*#__PURE__*/React.createElement(LabelDescriptionWrapper, null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    value: label
  })), /*#__PURE__*/React.createElement(Description, null, /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    value: description
  }))), /*#__PURE__*/React.createElement(ExtraColumnData, null, extraData)), isExpanded && /*#__PURE__*/React.createElement(ExpandableDetailsWrapper, null, expandableDetails));
}

var expandableColumnRenderer = function expandableColumnRenderer(_ref2) {
  var renderRowLabel = _ref2.renderRowLabel,
      renderRowDescription = _ref2.renderRowDescription,
      renderExtraData = _ref2.renderExtraData;
  return function (value, _ref3, grid) {
    var rowData = _ref3.rowData,
        isExpanded = _ref3.isExpanded;

    var _grid$getInstance = grid.getInstance(),
        renderExpandedDetails = _grid$getInstance.props.renderExpandedDetails,
        toggleExpand = _grid$getInstance.actions.toggleExpand;

    var expandableDetails = renderExpandedDetails({
      rowData: rowData
    });
    return /*#__PURE__*/React.createElement(ExpandableColumnCell, {
      description: renderRowDescription({
        rowData: rowData
      }),
      expandableDetails: expandableDetails,
      extraData: renderExtraData({
        rowData: rowData
      }),
      isExpanded: isExpanded,
      label: renderRowLabel({
        rowData: rowData
      }),
      onToggleExpand: function onToggleExpand() {
        return toggleExpand(rowData);
      }
    });
  };
};

var noop = function noop() {
  return null;
};

function createExpandableColumn(_ref4) {
  var property = _ref4.property,
      label = _ref4.label,
      _ref4$renderRowLabel = _ref4.renderRowLabel,
      renderRowLabel = _ref4$renderRowLabel === void 0 ? function () {
    return '----';
  } : _ref4$renderRowLabel,
      _ref4$renderRowDescri = _ref4.renderRowDescription,
      renderRowDescription = _ref4$renderRowDescri === void 0 ? noop : _ref4$renderRowDescri,
      _ref4$renderExtraData = _ref4.renderExtraData,
      renderExtraData = _ref4$renderExtraData === void 0 ? noop : _ref4$renderExtraData,
      width = _ref4.width,
      resizable = _ref4.resizable,
      sortable = _ref4.sortable,
      searchable = _ref4.searchable;
      _ref4.customRenderer;
      var rest = _objectWithoutProperties(_ref4, ["property", "label", "renderRowLabel", "renderRowDescription", "renderExtraData", "width", "resizable", "sortable", "searchable", "customRenderer"]);

  return _objectSpread(_objectSpread({}, rest), {}, {
    label: label,
    property: property,
    cell: {
      formatters: [expandableColumnRenderer({
        renderRowLabel: renderRowLabel,
        renderRowDescription: renderRowDescription,
        renderExtraData: renderExtraData
      })]
    },
    width: width || '50%',
    expandableColumn: true,
    resizable: resizable,
    sortable: sortable,
    searchable: searchable
  });
}

export default createExpandableColumn;
//# sourceMappingURL=ExpandableColumn.js.map
